import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import Laporan from '@/views/Laporan.vue'
import Artikel from '@/views/Artikel.vue'
import Infografis from '@/views/Infografis.vue'
import Tentang from '@/views/Tentang.vue'
import Jenis from '@/views/Jenis.vue'
import Kategori from '@/views/Kategori.vue'
import Pengguna from '../views/Pengguna.vue'
import Level from '../views/Level.vue'
import Login from '../views/Login.vue'
import Registrasi from '../views/Registrasi.vue'

function loggedInRedirectDashboard(to, from, next) {
    if (localStorage.token) {
      next('/');
    } else {
      next();
    }
}
  
function isLoggedIn(to, from, next) {
    if (localStorage.token) {
        const jwtPayload = JSON.parse(window.atob(localStorage.token.split('.')[1]))
        if (jwtPayload.exp < Date.now() / 1000) {
            localStorage.removeItem('token');
            localStorage.removeItem('profile');
            next('/login');
        }
      next();
    } else {
      next('/login');
    }
}

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        beforeEnter: isLoggedIn
    },
    {
        path: '/laporan',
        name: 'Laporan',
        component: Laporan,
        beforeEnter: isLoggedIn
    },
    {
        path: '/artikel',
        name: 'Artikel',
        component: Artikel,
        beforeEnter: isLoggedIn
    },
    {
        path: '/infografis',
        name: 'Infografis',
        component: Infografis,
        beforeEnter: isLoggedIn
    },
    {
        path: '/tentang',
        name: 'Tentang',
        component: Tentang,
        beforeEnter: isLoggedIn
    },
    {
        path: '/jenis_laporan',
        name: 'Jenis',
        component: Jenis,
        beforeEnter: isLoggedIn
    },
    {
        path: '/kategori_artikel',
        name: 'Kategori',
        component: Kategori,
        beforeEnter: isLoggedIn
    },
    {
        path: '/pengguna',
        name: 'Pengguna',
        component: Pengguna,
        beforeEnter: isLoggedIn
    },
    {
        path: '/level',
        name: 'Level',
        component: Level,
        beforeEnter: isLoggedIn
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        beforeEnter: loggedInRedirectDashboard,
    },
    {
        path: '/registrasi',
        name: 'Registrasi',
        component: Registrasi,
        beforeEnter: loggedInRedirectDashboard,
    }
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes
  })
  
  export default router